import { interWbSession } from '@interco/inter-webview-bridge'

async function isDark(): Promise<boolean> {
  const appInfo = await interWbSession.getAppInfo()
  return appInfo.isDarkMode
}

export default isDark
